import {getBundleVariation} from "./product-single";
import {EVENT_BUNDLE_VARIATION_CLICKED} from "../product-events";

const productSliders = {
    navigation: {
        instance: null
    },
    gallery: {
        instance: null
    }
}

const removeVariantSlide = (swiper) => {
    const slideToRemove = swiper.$el[0].querySelector('.variation-slide-remove');
    if(!slideToRemove) return;
    const index = slideToRemove.dataset.swiperSlideIndex;
    swiper.removeSlide(index);
}

document.addEventListener("DOMContentLoaded", function () {
    const isProductPage = document.querySelector(".eggo-product");

    if (!isProductPage) return;
    const productGalleryNoVariations = document.querySelector(".eggo-product__gallery--no-variation");
    productSliders.navigation.instance = new Swiper('.eggo-product__gallery-slider-navigation', {
        spaceBetween: 16,
        freeMode: true,
        slidesPerView: "auto"
    });

    productSliders.gallery.instance = new Swiper('.eggo-product__gallery-slider', {
        loop: true,
        slidesPerView: 1,
        thumbs: {
            swiper: productSliders.navigation.instance
        },
        navigation: {
            nextEl: ".product-swiper-button-next",
            prevEl: ".product-swiper-button-prev",
        }
    });
    productSliders.gallery.instance.on("slideChange", function (swiper) {
        const snapGrid = productSliders.navigation.instance.snapGrid;
        const snapInterval = snapGrid[1];
        productSliders.navigation.instance.slideTo(swiper.realIndex);
        productSliders.navigation.instance.translateTo(-snapInterval * (swiper.realIndex - 1));
        toggleSeeResults(swiper.realIndex > 0);
        toggleText(swiper.realIndex === 0);
    })

    eggoProductSmartGallery(productSliders.gallery.instance);

    if(productGalleryNoVariations) {
        document.addEventListener(EVENT_BUNDLE_VARIATION_CLICKED, (event) => {
            const variation = event.detail;
            removeVariantSlide(productSliders.gallery.instance);
            productSliders.gallery.instance.appendSlide(`<div class="swiper-slide variation-slide-remove"><img src="${variation.mainImage}" /></div>`);
            productSliders.gallery.instance.slideTo(-1, 0, false);
            productSliders.gallery.instance.once("slideChangeTransitionEnd", swiper => {
                removeVariantSlide(swiper);
            });
        });
    }
});

const eggoProductSmartGallery = (navigation) => {
    const variantColors = document.querySelectorAll(".product-card__variant-colors .product-card__variant-color");
    if (variantColors.length === 0) return;
    variantColors.forEach((color) => {
        color.addEventListener("click", () => {
            const thumbnails = document.querySelector(".eggo-product__gallery-slider");
            if (!thumbnails) return;
            const thumbnail = thumbnails.querySelector(`.swiper-slide[data-media-id='${color.dataset.mediaId}']`);
            if (!thumbnail) return;
            const swiperSlideIndex = thumbnail.dataset?.swiperSlideIndex;
            if (!swiperSlideIndex) return;
            navigation.slideTo(parseInt(swiperSlideIndex) + 1);
        });
    });
}

const toggleSeeResults = (show) => {
    const seeResultsLink = document.querySelector(".eggo-gallery-see-results");
    if (!seeResultsLink) return;
    show ? seeResultsLink.classList.add("visible") : seeResultsLink.classList.remove("visible");
}

const toggleText = (show) => {
    const textBadge = document.querySelector(".eggo-product__gallery-slider .text-badge");
    if (!textBadge) return;
    show ? textBadge.classList.add("visible") : textBadge.classList.remove("visible");
}